<template>
  <div class="container z-grid v-page-section-container-padding">
    <div class="z-grid__cols">
      <MoleculeFoldoutList v-if="items.length" :items="items" :color-theme="colorTheme" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  items: { type: Array as PropType<any[]>, required: true },
  colorTheme: { type: String, required: false, default: undefined },
})
</script>
